export default "__VITE_ASSET__DY$w1oRr__"